<template>
  <div class="py-4 container-fluid">
    <div class="row">
      <div class="col-12">
        <div class="card mb-3 shadow-sm">
          <div class="card-body p-3">
            <div class="row align-items-end">
              <div class="col-md-6 col-sm-12">
                <label class="text-xxs font-weight-bolder opacity-7 text-uppercase">Buscar por Nombre o Dirección</label>
                <input v-model="filters.search" type="text" class="form-control form-control-sm" placeholder="Ej: Sucursal Norte, Calle central...">
              </div>
              <div class="col-md-4 col-sm-10">
                <label class="text-xxs font-weight-bolder opacity-7 text-uppercase">Filtrar por Teléfono</label>
                <select v-model="filters.phone" class="form-select form-select-sm">
                  <option value="">Todos</option>
                  <option v-for="p in uniquePhones" :key="p" :value="p">{{ p }}</option>
                </select>
              </div>
              <div class="col-md-2 col-sm-2 text-end">
                <button class="btn btn-link text-danger p-0 mb-1" @click="resetFilters" title="Limpiar Filtros">
                  <i class="fa fa-sync"></i>
                </button>
              </div>
            </div>
          </div>
        </div>

        <div class="card mb-4">
          <div class="card-header pb-0 d-flex justify-content-between align-items-center">
            <h6>Sucursales Registradas ({{ filteredBranches.length }} resultados)</h6>
            <argon-button color="success" size="sm" @click="$router.push('/branches/create')">
              <i class="fa fa-plus me-1"></i> Nueva Sucursal
            </argon-button>
          </div>
          <div class="card-body px-0 pt-0 pb-2">
            <div v-if="isLoading" class="p-4 text-center">
              <div class="spinner-border text-primary" role="status"></div>
              <p class="mt-2 text-sm text-secondary">Cargando sucursales...</p>
            </div>

            <div v-else class="table-responsive p-0">
              <table class="table align-items-center mb-0">
                <thead>
                  <tr>
                    <th class="text-uppercase text-xxs font-weight-bolder opacity-7">Sucursal / Dirección</th>
                    <th class="text-uppercase text-xxs font-weight-bolder opacity-7 ps-2">Teléfono</th>
                    <th class="text-center text-uppercase text-xxs font-weight-bolder opacity-7">Coordenadas</th>
                    <th class="text-secondary opacity-7"></th>
                  </tr>
                </thead>
                <tbody>
                  <tr v-for="branch in filteredBranches" :key="branch.id">
                    <td>
                      <div class="d-flex px-3 py-1">
                        <div>
                          <div class="icon icon-shape icon-sm me-3 shadow text-center d-flex align-items-center justify-content-center border-radius-md bg-success">
                            <i class="fa fa-building text-white opacity-10"></i>
                          </div>
                        </div>
                        <div class="d-flex flex-column justify-content-center">
                          <h6 class="mb-0 text-sm">{{ branch.name }}</h6>
                          <p class="text-xs text-secondary mb-0 text-truncate" style="max-width: 250px;">{{ branch.address }}</p>
                        </div>
                      </div>
                    </td>
                    <td>
                      <p class="text-xs font-weight-bold mb-0">
                        <i class="fa fa-phone-alt me-1 text-muted"></i>
                        {{ branch.phone || '---' }}
                      </p>
                    </td>
                    <td class="align-middle text-center text-sm">
                      <span class="text-secondary text-xs font-weight-bold">
                        <i class="fa fa-map-marker-alt text-danger me-1"></i>
                        {{ branch.latitude }}, {{ branch.longitude }}
                      </span>
                    </td>
                    <td class="align-middle text-end px-4">
                      <button class="btn btn-link text-primary mb-0" @click="editBranch(branch.id)" title="Editar">
                        <i class="fa fa-pen text-xs"></i>
                      </button>
                      <button class="btn btn-link text-danger mb-0" @click="deleteBranch(branch.id)" title="Eliminar">
                        <i class="fa fa-trash text-xs"></i>
                      </button>
                    </td>
                  </tr>
                </tbody>
              </table>

              <div v-if="filteredBranches.length === 0" class="text-center p-4">
                <p class="text-sm text-secondary">No se encontraron sucursales registradas.</p>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import ArgonButton from "@/components/ArgonButton.vue";
import axios from "axios";
import Swal from "sweetalert2";

export default {
  name: "BranchesIndex",
  components: { ArgonButton },
  data() {
    return {
      branches: [],
      isLoading: true,
      companyId: localStorage.getItem('companyId'),
      filters: {
        search: '',
        phone: ''
      }
    };
  },
  computed: {
    // Generar lista única de teléfonos para el filtro
    uniquePhones() {
      return [...new Set(this.branches.map(b => b.phone).filter(p => p))].sort();
    },
    // Lógica de filtrado reactiva
    filteredBranches() {
      return this.branches.filter(branch => {
        const matchesSearch =
          branch.name?.toLowerCase().includes(this.filters.search.toLowerCase()) ||
          branch.address?.toLowerCase().includes(this.filters.search.toLowerCase());
        const matchesPhone = this.filters.phone === '' || branch.phone === this.filters.phone;

        return matchesSearch && matchesPhone;
      });
    }
  },
  methods: {
    resetFilters() {
      this.filters = { search: '', phone: '' };
    },
    async fetchBranches() {
      this.isLoading = true;
      const token = localStorage.getItem("accessToken");
      try {
        const response = await axios.get(`${this.$store.state.apiURL}branches`, {
          params: { company: this.companyId },
          headers: { 'Authorization': `Bearer ${token}` }
        });
        this.branches = response.data;
      } catch (error) {
        console.error("Error al cargar sucursales:", error);
      } finally {
        this.isLoading = false;
      }
    },
    editBranch(id) {
      this.$router.push(`/branches/${id}`);
    },
    async deleteBranch(id) {
      const result = await Swal.fire({
        title: '¿Eliminar sucursal?',
        text: "Esta acción no se puede revertir.",
        icon: 'warning',
        showCancelButton: true,
        confirmButtonColor: '#f5365c',
        confirmButtonText: 'Sí, eliminar',
        cancelButtonText: 'Cancelar'
      });

      if (result.isConfirmed) {
        const token = localStorage.getItem("accessToken");
        try {
          await axios.delete(`${this.$store.state.apiURL}branches/${id}`, {
            headers: { 'Authorization': `Bearer ${token}` }
          });
          this.fetchBranches(); // Recargar lista
          Swal.fire('Eliminado', 'Sucursal borrada correctamente', 'success');
        } catch (error) {
          Swal.fire('Error', 'No se pudo eliminar la sucursal', 'error');
        }
      }
    }
  },
  mounted() {
    this.fetchBranches();
  }
};
</script>

<style scoped>
.icon-shape {
  width: 36px;
  height: 36px;
}
</style>